<template>
  <analytics-sub-page
    title="Savings Analytics"
    icon="piggy-bank"
    css-class="analytics-savings"
    default-label="Savings"
    :section-specs="sectionSpecs"
  >
    <build-metrics ref="buildRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import BuildMetrics from '@/pages/analyticsApp/components/BuildMetrics.vue';

const buildRef = ref(null);

const sectionSpecs = [{ key: 'savings', label: 'Savings', ref: buildRef }];
</script>
